module.exports = __webpack_public_path__ + "images/7298e8412cf315d51063725632bdbeb8.svg";